import React, { useState } from "react";
import { Link } from "react-router-dom";

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <div style={{ width: "100%" }}>
            <div className="row menubar align-items-center">

                {/* LOGO */}
                <div className="col-md-4 col-8">
                    <div style={{ paddingLeft: "10%", paddingTop: "10px", paddingBottom: "10px" }}>
                        <div style={{float:'left',width:'80px'}}>
                            <img src="./images/ram-1.png" style={{ width: "100%" }} alt="" />
                        </div>
                        <div style={{float:'left'}}>
                            <span className="templename">
                                Pattarath Sree Chamundeswary Temple Trust
                               </span><br />
                            <span className="makreri-templename">
                               പട്ടാരത്ത് ശ്രീ ചാമുണ്ഡേശ്വരി ക്ഷേത്രം ട്രസ്റ്റ്
                            </span>
                        </div>


                    </div>
                </div>

                {/* HAMBURGER BUTTON (Mobile only) */}
                <div className="col-4 d-md-none text-end pe-4">
                    <button
                        className="btn btn-outline-warning humberger"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>
                </div>

                {/* MENU ITEMS */}
                {/* MENU ITEMS */}
                <div className={`col-md-8 menu-wrapper ${menuOpen ? "show" : ""}`}>
                    <div className="container containeritems">

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                                Home
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/History" className="menuitems" onClick={closeMenu}>
                                History
                            </Link>
                        </div>

                        <div className="boxes">
                            <a
                                href="#"
                                className="menuitems"
                                onClick={closeMenu}
                            >
                                Online Booking
                            </a>
                        </div>

                        <div className="boxes">
                            <Link to="/Timing" className="menuitems" onClick={closeMenu}>
                                Darsan Time
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Administration" className="menuitems" onClick={closeMenu}>
                                Administration
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Gallery" className="menuitems" onClick={closeMenu}>
                                Gallery
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Contact" className="menuitems" onClick={closeMenu}>
                                Contact
                            </Link>
                        </div>

                    </div>
                </div>


            </div>
        </div>
    );
}

export default MainMenu;
